<script setup>
  import { computed } from "vue";

  const props = defineProps({
    variant: { type: String, default: "fill" }, // fill | ghost | outlined
    color: { type: String, default: "blue" },
    size: { type: String, default: "md" }, // lg | md | sm
  });

  const chipClass = computed(
    () => `chip-${props.variant} chip-${props.color} chip-${props.size}`,
  );
</script>

<template>
  <span class="ui-chip" :class="chipClass"><slot /></span>
</template>

<style lang="scss" scoped>
  .ui-chip {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: var(--chip-bg-color, none);
    border-radius: var(--chip-border-radius, 0.25rem);
    border: var(--chip-border, none);
    color: var(--chip-text-color, var(--smoe-gray-800));
    font-size: var(--chip-font-size, 0.9375rem);
    font-weight: var(--chip-font-weight, 500);
    padding: var(--chip-padding, 0.25rem 0.5rem);
    height: var(--chip-height, 2rem);
    &.chip-fill {
      &.chip-blue {
        --chip-bg-color: var(--smoe-primary-500);
        --chip-text-color: var(--smoe-white);
      }
    }
    &.chip-ghost {
      &.chip-blue {
        --chip-bg-color: var(--smoe-primary-100);
        --chip-text-color: var(--smoe-primary-500);
      }
      &.chip-red {
        --chip-bg-color: var(--smoe-red-100);
        --chip-text-color: var(--smoe-red-500);
      }
      &.chip-yellow {
        --chip-bg-color: var(--smoe-yellow-100);
        --chip-text-color: var(--smoe-yellow-500);
      }
      &.chip-gray {
        --chip-bg-color: var(--smoe-gray-200);
        --chip-text-color: var(--smoe-gray-700);
      }
    }
    &.chip-outlined {
      &.chip-blue {
        --chip-bg-color: var(--smoe-white);
        --chip-border: 1px solid var(--smoe-primary-500);
        --chip-text-color: var(--smoe-primary-500);
      }
      &.chip-gray {
        --chip-bg-color: var(--smoe-white);
        --chip-border: 1px solid var(--smoe-border);
        --chip-text-color: var(--smoe-gray-700);
      }
    }
    &.chip-lg {
      --chip-height: 2.25rem;
      --chip-padding: 0.5rem;
      --chip-font-size: 1rem;
    }
    &.chip-md {
      --chip-height: 2rem;
      --chip-padding: 0.25rem 0.5rem;
      --chip-font-size: 0.9375rem;
    }
    &.chip-sm {
      --chip-height: 1.75rem;
      --chip-padding: 0.25rem 0.5rem;
      --chip-font-size: 0.875rem;
    }
  }
</style>
